import { useState } from "react";
import { PageHeader } from "@/components";
import DashboardLayout from "../app-layout";
import SettingsSidebar from "./components/settings-sidebar";
import AccountSection from "./components/account-section";
import { useIsMobile } from "@/hooks/use-mobile";

const SettingsPage = () => {
  const [activeSection, setActiveSection] = useState("profile");
  const isMobile = useIsMobile();

  const renderContent = () => {
    switch (activeSection) {
      case "profile":
        return <AccountSection />;
      default:
        return <AccountSection />;
    }
  };

  return (
    <DashboardLayout>
      <section className="w-full h-full overflow-y-auto space-y-2">
        <PageHeader
          title="Settings"
          mobileTitle="Settings"
          description="List below contains your data"
          mobileDescription="List below contains your data"
        />

        {/* Settings Content */}
        {isMobile ? (
          // Mobile Layout
          <div className="bg-white rounded-lg border border-gray-200">
            {/* Mobile Tabs */}
            <div className="flex border-b border-gray-200">
              <button
                onClick={() => setActiveSection("profile")}
                className={`flex-1 py-3 text-center font-medium relative ${
                  activeSection === "profile" ? "text-primary" : "text-gray-500"
                }`}
              >
                Profile Details
                {activeSection === "profile" && (
                  <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-primary"></div>
                )}
              </button>
            </div>

            {/* Mobile Content */}
            <div className="p-4">{renderContent()}</div>
          </div>
        ) : (
          // Desktop Layout
          <div className="bg-white rounded-lg border border-gray-200 min-h-[600px] flex">
            <SettingsSidebar
              activeSection={activeSection}
              onSectionChange={setActiveSection}
            />
            {renderContent()}
          </div>
        )}
      </section>
    </DashboardLayout>
  );
};

export default SettingsPage;
